// extracted by mini-css-extract-plugin
export default {"heading":"Pt-z","corrected":"Qt-z","redirectVerbiageContainer":"Rt-z","redirectVerbiageText":"St-z"};